import { ReactElement } from "react";

interface Props {
  children: ReactElement;
  active: boolean;
}

export const TabContent: React.FC<Props> = (props) => {
  if (props.active) {
    return props.children;
  }

  return null;
};
